type SeoSocialProps = {
  title: string;
  description: string;
  canonical: string;
  image?: string;
  type?: "website" | "article";
};

const DEFAULT_IMAGE = "https://painur.com/og-default.jpg";

export function seoSocialTags({
  title,
  description,
  canonical,
  image = DEFAULT_IMAGE,
  type = "website",
}: SeoSocialProps) {
  return [
    <meta key="og:locale" property="og:locale" content="he_IL" />,
    <meta key="og:type" property="og:type" content={type} />,
    <meta key="og:site_name" property="og:site_name" content="בית הרופאים באקה" />,
    <meta key="og:title" property="og:title" content={title} />,
    <meta key="og:description" property="og:description" content={description} />,
    <meta key="og:url" property="og:url" content={canonical} />,
    <meta key="og:image" property="og:image" content={image} />,
    <meta key="og:image:alt" property="og:image:alt" content={title} />,
    <meta key="twitter:card" name="twitter:card" content="summary_large_image" />,
    <meta key="twitter:title" name="twitter:title" content={title} />,
    <meta key="twitter:description" name="twitter:description" content={description} />,
    <meta key="twitter:image" name="twitter:image" content={image} />,
    <meta key="twitter:image:alt" name="twitter:image:alt" content={title} />,
  ];
}